module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('transition', {
    attrs: {
      "name": "slide-right"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menu),
      expression: "menu"
    }],
    staticClass: "sidebar__menu"
  }, [_c('transition', [(_vm.panel === 'tags') ? _c('div', {
    key: "tags",
    staticClass: "sidebar__panel--tags inner"
  }, [_c('button', {
    staticClass: "btn--close--white",
    on: {
      "click": function($event) {
        _vm.togglePanel(_vm.panel)
      }
    }
  }, [_c('span', {
    staticClass: "icon-tick"
  }), _vm._v(" Done")])]) : (_vm.panel === 'contact') ? _c('div', {
    key: "contact",
    staticClass: "sidebar__panel--contact inner"
  }, [_c('button', {
    staticClass: "btn--close--white",
    on: {
      "click": function($event) {
        _vm.togglePanel(_vm.panel)
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  }), _vm._v(" Close")])]) : (_vm.panel === 'info') ? _c('div', {
    key: "info",
    staticClass: "sidebar__panel--info inner"
  }, [_c('button', {
    staticClass: "btn--close--white",
    on: {
      "click": function($event) {
        _vm.togglePanel(_vm.panel)
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  }), _vm._v(" Close")])]) : _vm._e()])], 1)]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar__nav"
  }, [_c('h1', {
    staticClass: "logo"
  }, [_vm._v("\n        Northern Take\n      ")]), _vm._v(" "), _c('nav', {
    staticClass: "nav--main"
  }, [_c('ul')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3e52a08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 45
// module chunks = 1